/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Risk_High_OptimalInputs */

const en_coach_risk_high_optimal = /** @type {(inputs: Coach_Risk_High_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are training hard and your load has spiked into the danger zone. The combination of high fatigue and rapid ramp-up is the highest-risk scenario. Take a recovery day now.`)
};

const de_coach_risk_high_optimal = /** @type {(inputs: Coach_Risk_High_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du trainierst hart und die Belastung ist in die Gefahrenzone gestiegen. Hohe Ermüdung plus schneller Anstieg — das riskanteste Szenario. Mach jetzt einen Erholungstag.`)
};

/**
* | output |
* | --- |
* | "You are training hard and your load has spiked into the danger zone. The combination of high fatigue and rapid ramp-up is the highest-risk scenario. Take a r..." |
*
* @param {Coach_Risk_High_OptimalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_risk_high_optimal = /** @type {((inputs?: Coach_Risk_High_OptimalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Risk_High_OptimalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_risk_high_optimal(inputs)
	return de_coach_risk_high_optimal(inputs)
});